module.exports = __webpack_public_path__ + "static/media/red-taxi.63f27e91.png";